import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { useGetCollectionComponentTypeByIdMultilingual } from '@wajeez-web/components/helpers';

import { CollectionComponentTypeFormBuilder } from './CollectionComponentTypeFormBuilder';

interface CollectionComponentTypeCreateFormWithPrefilledDataProps {
  onSubmit: (collectionComponentTypeId: number) => void;
  onCancel: () => void;
}

export const CollectionComponentTypeCreateFormWithPrefilledData = ({
  onSubmit,
  onCancel,
}: CollectionComponentTypeCreateFormWithPrefilledDataProps) => {
  const collectionComponentTypeByIdMultilingual =
    useGetCollectionComponentTypeByIdMultilingual();

  return (
    <div>
      <h1 className="text-[24px] font-bold">
        <ReturnTranslatedText
          text={`pageHeader.${'Create New Type'}`}
          origintext="Create New Type"
        />
      </h1>
      <div className="mt-6">
        {collectionComponentTypeByIdMultilingual.data && (
          <CollectionComponentTypeFormBuilder
            type="Create"
            onSubmit={onSubmit}
            onCancel={onCancel}
            data={collectionComponentTypeByIdMultilingual.data}
          />
        )}
      </div>
    </div>
  );
};
